export const MOCK_SIZE = [
  {
    label: "XS",
    variant_id: "45493387067650",
    possible: 1,
    label_rank: 0,
    fit_indicators: [
      {
        limb: "hip",
        value: 2,
      },
    ],
  },
  {
    label: "S",
    variant_id: "45493387100418",
    possible: 1,
    label_rank: 1,
    fit_indicators: [
      {
        limb: "hip",
        value: 3,
      },
    ],
  },
  {
    label: "M",
    variant_id: "45493387133186",
    possible: 0,
    label_rank: 2,
    fit_indicators: [
      {
        limb: "hip",
        value: 5,
      },
    ],
  },
];

export const MOCK_RECOMMENDATION = [
  {
    label: "XS",
    variant_id: "45493387100418",
    possible: 1,
    label_rank: 1,
    fit_indicators: [
      {
        limb: "hip",
        value: 3,
      },
    ],
  },
  {
    label: "S",
    variant_id: "45493387067650",
    possible: 1,
    label_rank: 0,
    fit_indicators: [
      {
        limb: "hip",
        value: 2,
      },
    ],
  },
  {
    label: "M",
    variant_id: "45493387133186",
    possible: 0,
    label_rank: 2,
    fit_indicators: [
      {
        limb: "hip",
        value: 5,
      },
    ],
  },
];

export const MOCK_STOCKS_DATA = [
  {
    variant_reference: "45493387034882",
    quantity: 0,
  },
  {
    variant_reference: "45493387067650",
    quantity: 10,
  },
  {
    variant_reference: "45493387100418",
    quantity: 10,
  },
  {
    variant_reference: "45493387133186",
    quantity: 10,
  },
  {
    variant_reference: "45493387165954",
    quantity: 0,
  },
];

export const SMALL_PADDING_BRANDS = [
  "Lacoste",
  "KENZO",
  "Sporty & Rich",
  "Le Slip Français",
  "IZAC",
  "From Future",
  "Molli",
  "Place du Jour",
  "Gualap",
  "Vogstore",
];

export const MEDIUM_PADDING_BRANDS = [
  "JOTT",
  "Circle SportsWear",
  "Chlore",
  "SRP",
  "Hartford",
  "La Petite Etoile",
  "Mister K",
  "Petrone",
  "Bensimon",
  "Stella & Suzie",
  "Antonelle",
  "Kookai",
  "Une Jour Ailleurs",
  "Asphalte",
  "Place des Tendances",
  "Rodier",
  "La Canadienne",
  "Gerard Darel",
  "Ron Dorff",
  "The Kooples",
  "Nina Ricci",
  "Sport 2000",
  "Victoria Beckham",
];
